import { TrackingServices } from '../../plugins/Tracking';
import { UnifiedTrackingPlugin } from '../tracking/UnifiedTrackingPlugin';
import { AdobeTrackingMachine } from './AdobeTrackingMachine';
import { AdobeModuleGateway, AdobeOverseerGateway, AggregateAdobeGateway } from './AdobeGateway';
import AdobeCollectionAPI from '../../services/AdobeCollectionAPI/AdobeCollectionAPI';

export function adobePluginFactory(
  AdobeCollectionApi: ReturnType<typeof AdobeCollectionAPI>,
  playerName?: string
) {
  return ({ player, media$, liveTracking$ }: TrackingServices) => {
    const useActive = true;
    const instance = new UnifiedTrackingPlugin(
      () =>
        new AdobeTrackingMachine(
          new AggregateAdobeGateway([
            new AdobeModuleGateway(media =>
              AdobeCollectionApi.getInstance({ 'media.channel': media.entity.contentProvider })
            ),
            new AdobeOverseerGateway('Adobe Module V2'),
          ]),
          playerName!,
          useActive
        )
    );
    instance.track(player, media$, liveTracking$);
    return instance;
  };
}
